import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-solicitacoes-exclusao-dados',
  templateUrl: './solicitacoes-exclusao-dados.component.html',
  styleUrls: ['./solicitacoes-exclusao-dados.component.scss', '../../styles/estilo.padrao.scss']
})
export class SolicitacoesExclusaoDadosComponent implements OnInit {
  uid: string;
  bConsulta: boolean = false;

  displayedColumns: string[] = ['Nome', 'Email', 'Telefone', 'CPFCNPJ', 'DataHoraSolicitacao', 'sVisualizada', 'ConfirmarVisualizacao'];
  solicitacoesExclusaoDadosSource;
  $solicitacoes;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,

  ) {
    //@ts-ignore
    this.uid = localStorage.getItem('uid');
    this.spinner.show('solicitacoes-cadastro');
  }

  ngOnInit(): void {
    this.$solicitacoes = this.usuarioService.getAllSolicitacoesExclusaoDados().subscribe(snap => {
      this.solicitacoesExclusaoDadosSource = [];

      if (snap.length > 0) {
        let auxFornecedores: any[] = [];
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          auxFornecedores.push({
            ID: item.key,
            CPFCNPJ: dados.CPFCNPJ,
            Email: dados.Email,
            Nome: dados.Nome,
            Telefone: dados.Telefone,
            Timestamp: dados.TimestampCadastro,
            bVisualizada: dados.Status,
            sVisualizada: dados.Status ? 'Sim' : 'Não',
            DataHoraSolicitacao: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
          });
        });

        auxFornecedores = auxFornecedores.reverse();

        // this.usuarioService.setLog("Consulta geral de solicitações cadastro", null, this.uid);

        this.solicitacoesExclusaoDadosSource = new MatTableDataSource(auxFornecedores);
        this.solicitacoesExclusaoDadosSource.paginator = this.paginator;

        setTimeout(() => this.spinner.hide('solicitacoes-exclusao-dados'), 300);
      } else {
        this.toastr.error("Não foi possível localizar solicitações de exclusão de dados no sistema!", 'Erro');
        setTimeout(() => this.spinner.hide('solicitacoes-exclusao-dados'), 300);
      }
    });
  }

  confirmarVisualizacao(element: any) {
    if (confirm('Deseja confirmar a visualização de solicitação de exclusão de dado?')) {
      this.usuarioService.setConfirmarVisualizacaoExclusaoDeDado(element.ID).then((resp: any) => {
        this.usuarioService.setLog("Leitura de solicitação de exclusão de dados confirmada. ID da solicitação: " + element.ID, null, this.uid);

      });
    }
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.solicitacoesExclusaoDadosSource.filter = filterValue.trim().toLowerCase();

    if (this.solicitacoesExclusaoDadosSource.paginator) {
      this.solicitacoesExclusaoDadosSource.paginator.firstPage();
    }
  }

}
